export const SESSION_CI_WAIT_REASON = "Waiting for CI";

export const SESSION_DEPLOYMENT_WAIT_REASON = "Waiting for deployment";

export const SESSION_CHECKS_WAIT_REASONS = {
  ci: SESSION_CI_WAIT_REASON,
  deployment: SESSION_DEPLOYMENT_WAIT_REASON,
} as const;

export const SESSION_AGENTS_WAIT_REASON = "Waiting for sub-agents";

export const SESSION_AWAITING_REPO_REASON =
  "Waiting for the repository this Linear team works on";

export const SESSION_GATEWAY_APPROVAL_REASON =
  "Harness usage limit reached; waiting for AI Gateway approval";

export const SESSION_USAGE_WAIT_REASON =
  "Harness usage limit reached; waiting for capacity or a model change";

export const SESSION_EMPTY_TURN_APPROVAL_REASON =
  "The harness account returned an empty turn. Waiting for AI Gateway approval";

export const SESSION_EMPTY_TURN_WAIT_REASON =
  "The harness account returned an empty turn. Waiting for capacity or a model change";

export const SESSION_EMPTY_TURN_RESUMED_REASON =
  "Harness capacity is available again";

export const SESSION_INTERRUPTED_TURN_RECOVERY_REASON =
  "Resuming after an interruption";

// Sessions parked before the copy lost its em dash still carry these exact values.
export const LEGACY_SESSION_GATEWAY_APPROVAL_REASON =
  "Harness usage limit reached \u2014 waiting for AI Gateway approval";
export const LEGACY_SESSION_USAGE_WAIT_REASON =
  "Harness usage limit reached \u2014 waiting for capacity or a model change";
export const LEGACY_SESSION_QUOTA_WAIT_REASON =
  "Monthly spend quota reached \u2014 waiting for the next period or a raised ceiling";

export const SESSION_QUOTA_WAIT_REASON =
  "Monthly spend quota reached; waiting for the next period or a raised ceiling";

export const SESSION_CHECKOUT_WAIT_REASON =
  "Waiting for another session to finish its turn on the shared checkout";

export const SESSION_CHECKOUT_RESUMED_REASON = "Shared checkout released";

export const SESSION_CI_PASSED_REASON = "Checks passed";

export const SESSION_CI_FAILED_REASON = "CI checks failed";

export const SESSION_CI_STOPPED_REASON = "CI was stopped before it reported";

export const SESSION_CI_UNREPORTED_REASON = "CI did not report back";

export const SESSION_DEPLOYMENT_UNREPORTED_REASON =
  "The deployment did not report back";

export const SESSION_PR_MERGED_REASON = "Pull request merged";

/** Stored verbatim on failed sessions; the sidebar matches it to show a soft glyph instead of an error. */
export const SESSION_UNDELIVERED_REASON =
  "The branch holds commits the base does not, and no pull request is bound to this session. Push and open the pull request, or say why this work is not delivered that way.";

export const SESSION_PR_CLOSED_REASON = "Pull request closed";

export const SESSION_SANDBOX_CAPACITY_WAIT_REASON =
  "No Ares machine has room for this sandbox. Waiting for capacity";

export const SESSION_SANDBOX_CAPACITY_RESUMED_REASON =
  "Ares machine capacity is available again";

export const SESSION_SANDBOX_CAPACITY_EXPIRED_REASON =
  "No Ares machine freed up within 24 hours. Send a message to try again";
